export default "__VITE_ASSET__wVMhoBw4__"